module.exports = __webpack_public_path__ + "img/loading.22490215.gif";